var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 50,
    viewBox: "0 0 58 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3093 2.00021L56.7119 46.0002C56.946 46.4056 57.0692 46.8654 57.0692 47.3335C57.0692 47.8016 56.946 48.2615 56.7119 48.6668C56.4779 49.0722 56.1413 49.4089 55.7359 49.6429C55.3305 49.877 54.8707 50.0002 54.4026 50.0002H3.59726C3.12917 50.0002 2.66933 49.877 2.26395 49.6429C1.85858 49.4089 1.52195 49.0722 1.28791 48.6668C1.05387 48.2615 0.930661 47.8016 0.930664 47.3335C0.930667 46.8654 1.05388 46.4056 1.28793 46.0002L26.6906 2.00021C26.9247 1.59486 27.2613 1.25825 27.6667 1.02422C28.072 0.790196 28.5319 0.666992 28.9999 0.666992C29.468 0.666992 29.9278 0.790196 30.3332 1.02422C30.7386 1.25825 31.0752 1.59486 31.3093 2.00021ZM26.3333 36.6669V42.0002H31.6666V36.6669H26.3333ZM26.3333 18.0002V31.3335H31.6666V18.0002H26.3333Z",
    fill: "#D1001F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailModal);
export default __webpack_public_path__ + "static/media/failModal.95208ef2df54eaff9a7ad8eafee61053.svg";
export { ForwardRef as ReactComponent };